// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletBalance_container__39pp4","loadingSpinner":"WalletBalance_loadingSpinner__1Ujo2","row1":"WalletBalance_row1__2Isje","row2":"WalletBalance_row2__1ERFj"};